// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__N8WXo","col":"styles_col__1C9pr"};